import { render, staticRenderFns } from "./edit-office-form-old.vue?vue&type=template&id=c0f83468&"
import script from "./edit-office-form-old.vue?vue&type=script&lang=js&"
export * from "./edit-office-form-old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports